export default __webpack_public_path__ + "static/media/NERELLA_ADITHYA.e7bddf36.jpg";